
import {
  FbmakeStyles,
  FbTypeography,
  FbList,
  FbListItem,
  FbListItemText,
} from "@flexibees/core";
import { COLORS } from "../../constants/colors";
import { CustomCheckbox } from "./CustomCheckbox";
import PropTypes from "prop-types";
import "./Filter.css";
import ListItems from "./ListItems";

const useStyles = FbmakeStyles((theme) => ({
  root: {
    maxHeight: 300,
    overflow: "auto",
    backgroundColor: COLORS.WHITE,
    border: "none",
    borderRadius: 10,
  },
  input: {
    marginBottom: 10,
    height: 36,
    padding: 10,
  },
}));

export default function JobStatusFliter({
  data,
  onChange,
  checked,
}) {
  const classes = useStyles();

    return (
     <ListItems classes={classes} data={data} onChange={onChange} checked={checked}/>
    );
  }

JobStatusFliter.propTypes = {
  data: PropTypes.array.isRequired,
  checked: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
